import React, { useEffect, useState } from "react";
import API from '../Services/Discount'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";

const DiscountList = () => {
    const [name, setName] = useState("")
    const [date, setDate] = useState("")
    const [discountType, setDiscountType] = useState("")
    const [discountPer, setDiscountPer] = useState("")
    const [error, setError] = useState({});
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const perPage = 10
    const [discountList, setDiscountList] = useState([])
    const [id, setId] = useState([])
    const [status, setStatus] = useState("");
    const [createdAt, setCreatedAt] = useState("");

    useEffect(() => {
        getDiscountList()
    }, [currentPage])


    const handleSelectChange = (e, fieldName) => {
        const value = e.target.value;
        setDiscountType(value);
        if (value.trim()) {
            setError((prevErrors) => {
                const updatedErrors = { ...(prevErrors || {}) };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }
        if (fieldName === "discountType") {
            //  setDiscountPer(value);
        }
    };


    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        if (value.trim()) {
            setError((prevErrors) => {
                const updatedErrors = { ...(prevErrors || {}) };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }
        switch (fieldName) {
            case "name":
                setName(value);
                break;
            case "date":
                setDate(value);
                break;
            case "discountPer":
                setDiscountPer(value);
                break;
            default:
                break;
        }
    };
    const validateFields = () => {
        const errors = {};
        if (!(name?.trim())) errors.name = "Name is required";
        if (!(discountType?.trim())) errors.discountType = "Discount Type is required";
        const priceRegex = /^\d+(\.\d{1,2})?$/;
        if (!discountPer || String(discountPer).trim() === "") {
            errors.discountPer = "Discount amount is required";
        } else if (!priceRegex.test(String(discountPer))) {
            errors.discountPer = "Discount amount must be a valid number (e.g., 100 or 100.50)";
        } else if (discountType === "percentage" && parseFloat(discountPer) > 100) {
            errors.discountPer = "Discount percentage cannot exceed 100%";
        }
        setError(errors);
        return Object.keys(errors).length === 0;
    };


    const getDiscountList = async () => {
        try {
            const payload = {
                limit: perPage,
                pageNumber: currentPage
            };
            const response = await API.getDiscount(payload);
            // console.log("response data...", response?.data?.data?.count)
            setDiscountList(response?.data?.data?.rows)
            setTotalRecords(response?.data?.data?.count)
        } catch (error) {
            toast.dismiss();
            if (!error.response) {
                toast.error("Network error! Please check your internet connection");
            } else if (error.response.status === 403) {
                window.location.replace("/Login")
                toast.error("Network error! Please check your internet connection.");
            } else {
                toast.error("An unexpected error occurred. Please try again.");
            }
        }
    };

    const totalPages = Math.ceil(totalRecords / perPage);
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
            // getDiscountList();
        }
    };
    const getPageNumbers = () => {
        const maxVisible = 10;
        const pageNumbers = [];
        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            const left = Math.max(1, currentPage - 3);
            const right = Math.min(totalPages, currentPage + 3);
            if (left > 2) {
                pageNumbers.push(1, '...');
            } else {
                for (let i = 1; i < left; i++) {
                    pageNumbers.push(i);
                }
            }
            for (let i = left; i <= right; i++) {
                pageNumbers.push(i);
            }
            if (right < totalPages - 1) {
                pageNumbers.push('...', totalPages);
            } else {
                for (let i = right + 1; i <= totalPages; i++) {
                    pageNumbers.push(i);
                }
            }
        }
        return pageNumbers;
    };






    const handleError = (error) => {
        if (error.response) {
            toast.error(error.response.data?.message || `Error: ${error.response.status}`);
        } else if (error.request) {
            toast.error("No response from server. Please try again later.");
        } else {
            toast.error("Something went wrong. Please try again.");
        }
    };

    const changeStatus = async (id, currentStatus) => {
        const updatedStatus = !currentStatus;
        try {
            const response = await API.DiscountStatus(id, updatedStatus);
            if (response.status === 200) {
                setDiscountList((prevLocation) =>
                    prevLocation.map((item) =>
                        item.id === id ? { ...item, is_active: updatedStatus } : item
                    )
                );
                toast.success(
                    `Discount  ${updatedStatus ? "Activated" : "De-Activated"} successfully!`
                );
                getDiscountList();
            } else {
                console.log("Error updating status:", response);
                toast.error("Failed to update the status. Please try again.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.log("Error in status toggle:", error);
            handleError(error);
        }
    };

    const handleGetData = async (discountId) => {
        const paylaod = {
            pageNumber: currentPage,
            limit: perPage,
            id: discountId
        }
        try {
            const response = await API.getDiscount(paylaod);
            const fetchedData = response?.data?.data?.rows?.[0];
            // console.log(fetchedData, 'fetchedData');
            if (fetchedData) {
                //setHighlight(true);
                setId(fetchedData.id);
                setName(fetchedData?.name)
                setDate(fetchedData?.end_date)
                setDiscountType(fetchedData?.type)
                setDiscountPer(fetchedData?.discount)
                setStatus(fetchedData?.is_active);
                setCreatedAt(fetchedData?.createdAt);
            } else {
                toast.error("Failed to discount details.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.error("Error fetching data:", error);
        }
    };
    const handleSubmit = async () => {
        if (!validateFields()) return;
        await updateDiscountData();
    };


    const updateDiscountData = async () => {
        try {
            const formattedDate = date === "" ? null : date;
            const payload = {
                name: name,
                type: discountType,
                discount: discountPer,
                end_date: formattedDate
            };
            const response = await API.updateDiscountData(id, payload);
            if (response?.status === 200) {
                toast.success(response?.data?.message);
                getDiscountList()
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(response?.data?.message || "Failed to update discount Please try again.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.error("Error updating discount :", error);
            toast.error("An unexpected error occurred. Please try again later.");
        }
    }


    const handleCancel = () => {
        window.location.reload();
        setName('');
        setDate('');
        setDiscountType('')
        setDiscountPer('')
        setId(null);
    };

    return (
        <div>
            <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0">Added Discount</h4>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-bordered text-center">
                                <thead>
                                    <tr>
                                        <th>SrNo</th>
                                        <th>Action</th>
                                        <th>Name</th>
                                        <th>Type</th>
                                        <th>Discount</th>
                                        <th>Status</th>
                                        <th>End-Date</th>
                                        <th>created-Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {discountList.map((item, index) => (
                                        <tr key={item.id} data-active={item?.is_active ? "true" : "false"}>
                                            <td>{(currentPage - 1) * perPage + index + 1}</td>

                                            <td>
                                                <div className="navbar-menu-wrapper d-flex align-items-stretch" style={{ justifyContent: 'center', alignItems: "center", display: "flex" }}>
                                                    <ul className="navbar-nav navbar-nav-right">
                                                        <li className="nav-item nav-profile1">
                                                            <span className="nav-link dropdown-toggle1 text-center" id="actionDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <div className="nav-profile-text1">
                                                                    <p className="mb-1 text-black">
                                                                    </p>
                                                                </div>
                                                            </span>
                                                            <span className="nav-link mdi mdi-menu" style={{ width: "50px", fontSize: "30px", color: "black", }} id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false"></span>
                                                            <div className="dropdown-menu navbar-dropdown" aria-labelledby="actionDropdown">
                                                                <a className="dropdown-item">
                                                                    <button onClick={() => handleGetData(item.id)} className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModalViewDiscount">
                                                                        View
                                                                    </button>
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                <a className="dropdown-item">
                                                                    <button onClick={() => handleGetData(item.id)}
                                                                        className="btn btn-primary btn-sm" type="button"
                                                                        data-bs-toggle="modal" data-bs-target="#myModal"
                                                                    >
                                                                        Edit
                                                                    </button>
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                <a className="dropdown-item">

                                                                    <button
                                                                        className={`btn btn-sm ${item.is_active ? "btn-secondary" : "btn-info"}`}
                                                                        onClick={() => changeStatus(item.id, item.is_active)}
                                                                    >
                                                                        {item.is_active ? "De-Activate" : "Activate"}
                                                                    </button>

                                                                </a>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </td>
                                            <td>{item.name}</td>
                                            {/* <td>{item.type}</td> */}
                                            <td>
                                                {item.type}
                                                {typeof item.type === 'string' && item.type.toLowerCase().includes('amount') && (
                                                    <> (<span className="mdi mdi-currency-rupee"></span>)</>
                                                )}
                                            </td>

                                            <td>{item.discount}</td>

                                            <td>{item?.is_active ? "Active" : "De-Activated"}</td>
                                            <td>
                                                {moment(item.end_date).isValid() ? moment(item.end_date).format("DD-MM-YYYY") : ""}
                                            </td>
                                            <td>
                                                {moment(item.createdAt).format("DD-MM-YYYY")}
                                            </td>
                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination justify-content-center mt-4">
                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            Previous
                                        </button>
                                    </li>

                                    {getPageNumbers().map((page, index) => (
                                        <li
                                            key={index}
                                            className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
                                        >
                                            {page === "..." ? (
                                                <span className="page-link">...</span>
                                            ) : (
                                                <button className="page-link" onClick={() => handlePageChange(page)}>
                                                    {page}
                                                </button>
                                            )}
                                        </li>
                                    ))}
                                    <li
                                        className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
            <section>
                <div className="modal fade" id="myModal" data-bs-backdrop="static">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">

                            <div className="modal-header">
                                <h4 className="modal-title">Update Discount</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>

                            <div className="modal-body">

                                <div className="row g-3">
                                    {/* Name Field */}
                                    <div className="col-md-6">
                                        <label htmlFor="txtName" className="form-label">Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="txtName"
                                            placeholder="Name"
                                            value={name}
                                            onChange={(e) => handleFieldChange(e, "name")}
                                        />
                                        {error?.name && (
                                            <div className="text-danger small mt-1">{error.name}</div>
                                        )}
                                    </div>

                                    {/* End Date Field */}
                                    <div className="col-md-6">
                                        <label htmlFor="txtDate" className="form-label">End Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            id="txtDate"
                                            value={date}
                                            onChange={(e) => handleFieldChange(e, "date")}
                                        />
                                        {error?.date && (
                                            <div className="text-danger small mt-1">{error.date}</div>
                                        )}
                                    </div>

                                    {/* Discount Type */}
                                    <div className="col-md-6">
                                        <label htmlFor="ddtime" className="form-label">Discount Type <span className="text-danger">*</span></label>
                                        <select
                                            className="form-select"
                                            id="ddtime"
                                            value={discountType}
                                            onChange={(e) => handleSelectChange(e, "discountType")}
                                        >
                                            <option value="">Select Discount Type</option>
                                            <option value="percentage">Discount %</option>
                                            <option value="amount">Discount Amount</option>
                                        </select>
                                        {error?.discountType && (
                                            <div className="text-danger small mt-1">{error.discountType}</div>
                                        )}
                                    </div>

                                    {/* Conditional Discount Input */}
                                    <div className="col-md-6">
                                        {discountType === "percentage" && (
                                            <>
                                                <label htmlFor="txtDiscountper" className="form-label">Discount % <span className="text-danger">*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="txtDiscountper"
                                                    placeholder="Enter Discount %"
                                                    value={discountPer}
                                                    onChange={(e) => handleFieldChange(e, "discountPer")}
                                                />
                                                {error?.discountPer && (
                                                    <div className="text-danger small mt-1">{error.discountPer}</div>
                                                )}
                                            </>
                                        )}

                                        {discountType === "amount" && (
                                            <>
                                                <label htmlFor="txtDiscountamount" className="form-label">Discount Amount (<span className="mdi mdi-currency-rupee"></span>)</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="txtDiscountamount"
                                                    placeholder="Enter Discount Amount"
                                                    value={discountPer}
                                                    onChange={(e) => handleFieldChange(e, "discountPer")}
                                                />
                                                {error?.discountPer && (
                                                    <div className="text-danger small mt-1">{error.discountPer}</div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>

                                <div className="d-flex justify-content-end gap-2 mt-4">
                                    <button className="btn btn-primary" onClick={handleSubmit}>Update</button>

                                    <button onClick={handleCancel} type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="modal" id="myModalViewDiscount">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Discount Details</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                {/* End-Date	created-Date */}
                                <table className="table table-bordered border-secondary">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Type</th>
                                            <th>Discount</th>
                                        </tr>
                                        <tr>
                                            <td>{name}</td>
                                            <td>
                                                {discountType}
                                                {typeof discountType === 'string' && discountType.toLowerCase().includes('amount') && (
                                                    <> (<span className="mdi mdi-currency-rupee"></span>)</>
                                                )}

                                            </td>
                                            <td>{discountPer}</td>
                                        </tr>
                                        <tr><th>End Date</th>
                                            <th>Status</th>
                                            <th>Created Date</th>
                                        </tr>
                                        <tr>
                                            <td>{date || "N/A"}</td>
                                            <td>{status ? "Active" : "De-Activated"}</td>
                                            <td>{moment(createdAt).format("DD-MM-YYYY")}
                                            </td>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                            <div className="modal-footer">
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

    );
};

export default DiscountList;